// First: before any module builds a schema.
import "./zod-config.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n/i18n.ts";
import { ConsoleRoot } from "./console/ConsoleRoot.tsx";
import { setRouterSite } from "./router.tsx";
import "./index.css";

// The console website's entry (openspec change operator-identity-pool, D6): `console.html`,
// served on the console's own origin only. It mounts the console and its sign-in, never a
// tenant screen.
// Its routes sit at the root (#390): telemetry and feedback name them with the console parser.
setRouterSite("console");
const queryClient = new QueryClient();
const root = document.getElementById("root");
if (!root) {
  throw new Error("#root not found");
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConsoleRoot />
    </QueryClientProvider>
  </StrictMode>,
);
